import {getEnv} from '@config/getEnv';
import {IFetchParams} from './http.model';
import {makeRequest} from './http.util';

export const makeMockedRequest = async <T>(
    url: string,
    params: IFetchParams,
) => {
    const res = await makeRequest<T>(
        getEnv('NEXT_PUBLIC_MOCK_URL') +
            '/mock/use?url=' +
            encodeURIComponent(url),
        params,
    );
    return res;
};
